import { ModelRow } from "@mcleod/core";
import { SecondaryFilterProps } from "@mcleod/dispatch";

export class DriverSettlementTaskFilter {
    static readonly SUMMARY_PROCESS: SecondaryFilterProps = {
        id: "summaryProcess",
        caption: "In Summary Process",
        filter: (row: ModelRow) => {
            return row.get("process_status") == "S";
        }
    }

    static readonly PAYMENT_PROCESS: SecondaryFilterProps = {
        id: "paymentProcess",
        caption: "In Payment Process",
        filter: (row: ModelRow) => {
            return row.get("process_status") == "C";
        }
    }
}
